import { render } from "./ReviewsContentRank2.vue?vue&type=template&id=16ddacde&scoped=true"
const script = {}

import "./ReviewsContentRank2.vue?vue&type=style&index=0&id=16ddacde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ddacde"]])

export default __exports__